export const POSITION_LATLNG = 'POSITION_LATLNG'